<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10XT7jn/tc-custom/9781459293168.jpg?1728724770456" alt="This image is the cover for the book Secret He Must Claim, The Saunderson Legacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret He Must Claim, The Saunderson Legacy
      </h1>
      <p class="bookDescription body article font2">
        <b><i>USA Today</i>–Bestselling Author: An illicit encounter with a mysterious Spaniard leads to unexpected consequences . . . </b><br/><br/>Heiress Elin Saunderson is instantly seduced by mysterious stranger Cortez. But after their sinful night together she’s left alone . . . and pregnant. A year later, she learns that Cortez is the rightful successor to her adoptive father’s fortune, and penniless Elin finds herself at risk of losing everything—including her son!<br/><br/>Cortez Ramos is set on claiming the secret Elin kept from him—but Elin proves as protective a mother as she is a torturous temptation. His solution: demand a marriage of convenience, which will legitimize his heir and return Elin to his bed . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chantelle Shaw
      </h2>
      
      <p class="authorDescription body article">Chantelle Shaw enjoyed a happy childhood making up stories in her head. Always an avid reader, Chantelle discovered Mills &amp; Boon as a teenager and during the times when her children refused to sleep, she would pace the floor with a baby in one hand and a book in the other! Twenty years later she decided to write one of her own. Writing takes up most of Chantelle&rsquo;s spare time, but she also enjoys gardening and walking.&#160;She doesn't find domestic chores so pleasurable!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e9d2326